// Module
var code = "<svg id=\"bookmark_black_24dp\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n  <path id=\"Path_7556\" data-name=\"Path 7556\" d=\"M0,0H24V24H0Z\" fill=\"none\"/>\n  <path id=\"Path_7557\" data-name=\"Path 7557\" d=\"M17,3H7A2,2,0,0,0,5.01,5L5,21l7-3,7,3V5A2.006,2.006,0,0,0,17,3Z\" fill=\"currentColor\"/>\n</svg>\n";
// Exports
module.exports = code;